import { Grid } from '@material-ui/core';
import DrillxReactSelect from 'components/DrillxReactSelect';
import { ObjectKeys } from 'helpers/ts-helpers';
import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ValueType } from 'react-select';
import { updateUser } from 'redux/User';
import { useSelectUser } from 'redux/User/selectors';
import userApiClient from 'services/networking/userApiClient';
import { unitSystemNames, UnitSystems } from 'types/unitSystem';

import styles from '../../ProfilePopup.module.scss';

type UnitSystemOptionType = { value: UnitSystems; label: string };

const UnitSelect: FC = () => {
  const intl = useIntl();
  const [isUserLoading, setIsUserLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const user = useSelectUser();

  const getUnitSystemChoice = (unitSystemId: UnitSystems): UnitSystemOptionType => ({
    value: unitSystemId,
    label: unitSystemNames[unitSystemId],
  });

  const onUnitSystemChange = async (selectedOption: ValueType<UnitSystemOptionType>) => {
    setIsUserLoading(true);
    const value = (selectedOption as UnitSystemOptionType).value;
    const newUser = await userApiClient.patchUserUnitSystem(value);
    if (newUser) dispatch(updateUser(newUser));

    setIsUserLoading(false);
  };

  return (
    <Grid className={styles.selector}>
      <span className={styles.selectorTitle}>
        {intl.formatMessage({ id: 'header.profile.unitSystem' })}
      </span>
      <DrillxReactSelect
        isLoading={isUserLoading}
        value={getUnitSystemChoice(user?.unitSystem ?? UnitSystems.METRIC)}
        options={ObjectKeys(unitSystemNames).map(getUnitSystemChoice)}
        onChange={onUnitSystemChange}
        isSearchable={false}
      />
    </Grid>
  );
};

export default UnitSelect;
